import * as React from "react";

function ExitRightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M15.887 8.036l-3.354 3.354-.707-.707 2.147-2.147H7v-1h6.973L11.826 5.39l.707-.707 3.354 3.353zM9 12.536a.5.5 0 01-.5.5h-6a.5.5 0 01-.5-.5v-9a.5.5 0 01.5-.5h6a.5.5 0 01.5.5v1.5h1v-1.5a1.5 1.5 0 00-1.5-1.5h-6a1.5 1.5 0 00-1.5 1.5v9a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5v-1.5H9v1.5z"
  }));
}

export default ExitRightIcon;